<template>
  <div class="modal-body">
      <toast ref="toast"></toast>

      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a href="#tab1" class="nav-link active" data-toggle="tab" @click="setTab(1)">最新</a>
        </li>
        <li class="nav-item">
          <a href="#tab2" class="nav-link" data-toggle="tab" @click="setTab(2)">履歴</a>
        </li>
      </ul>

      <div class="tab-content">
        <!-- 最新タブ -->
        <div v-show="tab == 1" class="tab-pane pt-3 active">
          <user-work-registration-view :result="result.userWorkRegistrationList[0]" :loginUser="loginUser"></user-work-registration-view>
        </div>

        <!-- 一覧タブ -->
        <div v-show="tab == 2" class="tab-pane pt-3 active">
          <span v-if="result.userWorkRegistrationList == null || result.userWorkRegistrationList.length == 0">なし</span>
          <table v-else>
            <thead class="thead-light">
              <tr>
                  <th>No</th>
                  <th>作成日</th>
                  <th>更新日</th>
                  <th>添付</th>
                  <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in result.userWorkRegistrationList" :key="list.id">
                <td><a href="#" @click="showHistory(list)">{{result.userWorkRegistrationList.length - index}}回目</a></td>
                <td>{{list.createdAt}}</td>
                <td>{{list.modifiedAt}}</td>
                <td>{{list.imageUrl ? 'あり' : 'なし'}}</td>
                <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
                    <button type="button" class="btn btn-sm btn-outline-info" @click="goWorkRegistrarionEdit(list.userId, list.id)"><i class="fa fa-edit"></i>編集</button>
                    <a :href="'/api/user/download/excel/' + list.id">
                      <button type="button" class="btn btn-info btn-sm" style="border-radius:50px;">
                          <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>Excel
                      </button>
                    </a>
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="deleteUserWorkRegistration(list.id)"><i class="fa fa-trash"></i>削除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 参照タブ -->
        <div v-show="tab == 3" class="tab-pane pt-3 active">
          <user-work-registration-view :result="showResult" :loginUser="loginUser"></user-work-registration-view>
        </div>
      </div>
  </div>
</template>

<style scoped>
.icon {
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
}
.ragistration th {
  background-color: #f0f0f0;
}
</style>

<script>
import UserWorkRegistrationView from './UserWorkRegistrationView.vue'
import UserAPI from '../../../api/user-api'
import Toast from '../../Toast.vue'
import moment from 'moment'

export default {
  name: "user-work-registration-view-summary",
  components: {
    Toast,
    UserWorkRegistrationView
  },
  props: {
    result: Object,
    loginUser: Object
  },
  data() {
    return {
      tab: 1,
      showResult: {}
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    showHistory(result){
      this.tab = 3;
      this.showResult = result
    },
    setTab(index) {
      this.tab = index;
    },
    // 前の画面へ
    goBack () {
        this.$root.$refs.loading.$data.show = true
        this.$router.go(-1)
    },
    goWorkRegistrarionCreate(userId) {
        this.$router.push('/admin/user/work-registration/edit/' + userId)
    },
    goWorkRegistrarionEdit(userId, id) {
        $(".close").click()
        this.$root.$refs.loading.$data.show = true
        this.$router.push('/admin/user/work-registration/edit/' + userId + "?id=" + id)
    },
    // 勤務登録削除
    deleteUserWorkRegistration (id) {
      if (window.confirm('削除してよろしいですか?')){
          this.$root.$refs.loading.$data.show = true
          UserAPI.deleteUserWorkRegistration(id)
            .then(res => {
              this.result.userWorkRegistrationList = this.result.userWorkRegistrationList.filter(function(list){
                return list.id != id
              })
              this.$forceUpdate()
              this.$refs.toast.showToast("削除しました", 3000, false)
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      }
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
  },
  computed: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/user/UserWorkRegistrationViewSummary.vue